import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSearchIntelligence: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSearchIntelligence"><Path d="M10 3.56604C6.33064 4.05493 3.5 7.19688 3.5 11C3.5 15.1421 6.85786 18.5 11 18.5C14.8031 18.5 17.945 15.6693 18.4339 12" stroke="currentColor"/><Path d="M20.2498 20.2498L16.2998 16.2998" stroke="currentColor" strokeLinecap="square"/><Path d="M16.35 2.5H15.65L14.775 4.775L12.5 5.65V6.35L14.775 7.225L15.65 9.5H16.35L17.225 7.225L19.5 6.35V5.65L17.225 4.775L16.35 2.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconSearchIntelligence;
